/**
 * SearchInput Component
 * Reusable search input with debounced onChange
 * Used by: FindPage, NewsPage, OpportunitiesPage
 */

import React, { useState, useEffect } from 'react';

const SearchInput = ({
  placeholder = 'Search...',
  onSearch,
  debounceMs = 300,
  initialValue = '',
  style = {}
}) => {
  const [value, setValue] = useState(initialValue);

  // Debounce the search callback
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearch(value);
    }, debounceMs);

    return () => clearTimeout(timer);
  }, [value, debounceMs, onSearch]);

  return (
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      style={{
        padding: '10px 14px',
        borderRadius: '4px',
        border: '1px solid #ccc',
        fontSize: '15px',
        width: '100%',
        maxWidth: '400px',
        ...style
      }}
    />
  );
};

export default SearchInput;
